"use client";

import React from "react";

interface BusinessComponentWrapperProps {
  title?: string;
  children: React.ReactNode;
}

export const BusinessComponentWrapper: React.FC<
  BusinessComponentWrapperProps
> = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      {title && <p className="title_l text-content_primary">{title}</p>}
      {children}
    </div>
  );
};
